/* eslint-disable global-require */
import { startApp } from "@quintype/framework/client/start";
import { renderApplication, preRenderApplication } from "./render";
import "../../app/assets/stylesheets/app.scss";
import CustomReducers from "../isomorphic/components/helper/reducers";

function enableHotReload(store) {
  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./render", () => renderApplication(store));
  }
}

// Removed wretch import
// import wretch from "wretch";

// Store reference to the AdSense script element
let adsbygoogleScript = null;

// Function to check if script should be loaded/removed
function shouldLoadAdSenseScript() {
  const userID = localStorage.getItem("userID");
  const activeDigitalSub = localStorage.getItem("activeDigitalSub");
  const isUserLoggedIn = userID && userID !== "";
  const hasDigitalSubscription = activeDigitalSub === "true";

  console.log("[AdSense Script] Checking conditions:", {
    userID: userID || "not set",
    activeDigitalSub: activeDigitalSub || "not set",
    isUserLoggedIn: isUserLoggedIn,
    hasDigitalSubscription: hasDigitalSubscription,
    shouldLoadScript: !(isUserLoggedIn && hasDigitalSubscription)
  });

  // Script should NOT load if user is logged in AND has digital subscription
  return !(isUserLoggedIn && hasDigitalSubscription);
}

// Function to remove AdSense script if it exists
function removeAdSenseScript() {
  console.log("[AdSense Script] Attempting to remove script...");

  let removed = false;
  if (adsbygoogleScript && adsbygoogleScript.parentNode) {
    adsbygoogleScript.parentNode.removeChild(adsbygoogleScript);
    adsbygoogleScript = null;
    removed = true;
    console.log("[AdSense Script] Script removed from stored reference");
  }

  // Also try to find and remove by src attribute as fallback
  const scripts = document.querySelectorAll('script[src*="adsbygoogle.js"]');
  if (scripts.length > 0) {
    scripts.forEach(script => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
        removed = true;
        console.log("[AdSense Script] Script removed via fallback method");
      }
    });
  }

  if (!removed) {
    console.log("[AdSense Script] No script found to remove");
  } else {
    console.log("[AdSense Script] Script successfully removed");
  }
}

// Function to check and handle script removal when conditions change
function checkAndHandleAdSenseScript() {
  const shouldLoad = shouldLoadAdSenseScript();
  const scriptExists = !!adsbygoogleScript;

  console.log("[AdSense Script] Monitoring check:", {
    shouldLoadScript: shouldLoad,
    scriptCurrentlyLoaded: scriptExists
  });

  if (!shouldLoad && adsbygoogleScript) {
    // User logged in with subscription, remove script
    console.log("[AdSense Script] User is logged in with digital subscription - removing script");
    removeAdSenseScript();
  }
}

// Monitor localStorage changes and custom events
function setupAdSenseScriptMonitor() {
  // Listen for storage events (fires when localStorage changes in other tabs/windows)
  window.addEventListener("storage", (e) => {
    if (e.key === "activeDigitalSub" || e.key === "userID") {
      checkAndHandleAdSenseScript();
    }
  });

  // Listen for custom userIDUpdated event
  window.addEventListener("userIDUpdated", () => {
    console.log("[AdSense Script] userIDUpdated event detected, checking after 2s delay...");
    // Wait a bit for subscription check to complete, then check
    setTimeout(() => {
      checkAndHandleAdSenseScript();
    }, 2000);
  });

  // Poll localStorage periodically to catch changes in the same tab
  // (since storage event doesn't fire in same tab)
  let lastUserID = localStorage.getItem("userID");
  let lastActiveDigitalSub = localStorage.getItem("activeDigitalSub");

  setInterval(() => {
    const currentUserID = localStorage.getItem("userID");
    const currentActiveDigitalSub = localStorage.getItem("activeDigitalSub");

    if (currentUserID !== lastUserID || currentActiveDigitalSub !== lastActiveDigitalSub) {
      console.log("[AdSense Script] localStorage change detected:", {
        userID: { from: lastUserID || "not set", to: currentUserID || "not set" },
        activeDigitalSub: { from: lastActiveDigitalSub || "not set", to: currentActiveDigitalSub || "not set" }
      });
      lastUserID = currentUserID;
      lastActiveDigitalSub = currentActiveDigitalSub;
      checkAndHandleAdSenseScript();
    }
  }, 1000); // Check every second
}

// Start monitoring
console.log("[AdSense Script] Initializing AdSense script monitor...");
setupAdSenseScriptMonitor();
console.log("[AdSense Script] Monitor started - tracking userID and activeDigitalSub changes");

window.addEventListener("load", () => {
  const id = setTimeout(() => {
    // Polyfills for old browsers
    if (
      !window.fetch ||
      !window.Array.prototype.map ||
      !window.Promise ||
      !window.URLSearchParams ||
      !window.IntersectionObserver ||
      !window.Set
    ) {
      const t = document.createElement("script");
      t.type = "text/javascript";
      t.defer = true;
      t.src = "https://cdn.polyfill.io/v2/polyfill.min.js?features=default,IntersectionObserver,fetch";
      document.getElementsByTagName("head")[0].appendChild(t);
    }

    // Check if script should be loaded
    const shouldLoad = shouldLoadAdSenseScript();
    if (shouldLoad) {
      console.log("[AdSense Script] Loading Google AdSense script...");
      const s1 = document.createElement("script");
      s1.dataset.adClient = "ca-pub-9709396780967432";
      s1.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      s1.defer = true;
      adsbygoogleScript = s1; // Store reference
      document.getElementsByTagName("head")[0].appendChild(s1);
      console.log("[AdSense Script] ✓ Script loaded successfully");
    } else {
      console.log("[AdSense Script] ✗ Script NOT loaded - User is logged in with digital subscription");
    }

    const gumletScript = document.createElement("script");
    gumletScript.defer = true;
    gumletScript.src = "https://cdn.gumlet.com/gumlet.js/2.0/gumlet.min.js";
    document.body.appendChild(gumletScript);

    clearTimeout(id);
  }, 4750);
});

// removed: global.wretch = wretch;
global.width = window.innerWidth;

startApp(renderApplication, CustomReducers, {
  preRenderApplication,
  enableServiceWorker: process.env.NODE_ENV === "production",
  appVersion: require("../isomorphic/app-version")
}).then(enableHotReload);
